import { cn } from 'util/cn'

import axiosOriginal from 'axios'
import { css } from 'design'
import { Button, buttonStyles } from 'primitives/button'
import { Stack } from 'primitives/containers'
import React, { useContext, useEffect, useState } from 'react'

import { WidgetHeaderBar } from '../../../components/live_chat_widget/widget_header_bar'
import { ArrowLeft, ArrowRight } from '../../../images'
import { AppLocationContext } from '../../admin/app_location_provider'
import { WidgetPageContainer } from '../widget_page_container'
import { SlideIndicator } from './slide_indicator'
import { spacerStyles } from './styles'

export const Product = () => {
  const [cartData, setCartData] = useState<any>()
  const [productData, setProductData] = useState<any>()
  const [selectedVariantId, setSelectedVariantId] = useState<
    number | undefined
  >()
  const { appLocation } = useContext(AppLocationContext)
  const [selectedImage, setSelectedImage] = useState(0)
  const image = productData?.images?.[selectedImage]
  const selectedVariant = productData?.variants?.[selectedVariantId]
  const [selectedOptions, setSelectedOptions] = useState({})
  const [preloadedImages, setPreloadedImages] = useState<any>({ 0: true })

  useEffect(() => {
    window.cartCallback = (result: any) => {
      setCartData(result)
    }

    const s = document.createElement('script')
    s.type = 'text/javascript'
    const { protocol, hostname } = new URL(appLocation.productURL || '')
    s.src = `${protocol}//${hostname}/cart.json?callback=cartCallback`
    document.head.appendChild(s)
  }, [appLocation.productURL])

  useEffect(() => {
    axiosOriginal.get(`${appLocation.productURL}.json`).then((result) => {
      setProductData({
        ...result.data.product,
        variants: result.data.product.variants.reduce(
          (acc: any, variant: any) => {
            acc[variant.id] = variant
            return acc
          },
          {},
        ),
      })
    })
  }, [appLocation.productURL])

  useEffect(() => {
    if (productData) {
      const variant: any = Object.values(productData.variants).find(
        (v: any) => v.position === 1,
      )
      setSelectedVariantId(variant.id)
      setSelectedOptions(
        productData.options.reduce((acc: any, option: any, index: number) => {
          acc[option.id] = variant[`option${index + 1}`]
          return acc
        }, {}),
      )
    }
  }, [productData])

  useEffect(() => {
    if (productData?.images?.length) {
      const nextImageId = (selectedImage + 1) % productData.images.length
      if (preloadedImages[nextImageId]) {
        return
      }
      const preloadNextImage = new Image()
      preloadNextImage.src = productData.images[nextImageId].src
      setPreloadedImages((prevState: any) => {
        return {
          ...prevState,
          [nextImageId]: true,
        }
      })
    }
  }, [preloadedImages, productData?.images, selectedImage])

  const previousImage = () => {
    setSelectedImage(
      (prevState) =>
        (prevState === 0 ? productData.images.length - 1 : prevState - 1) %
        productData.images.length,
    )
  }

  const nextImage = () => {
    setSelectedImage((prevState) => (prevState + 1) % productData.images.length)
  }

  const onOptionChange = (event: any) => {
    setSelectedOptions((prevState) => {
      const newState = {
        ...prevState,
        [event.target.name]: event.target.value,
      }
      const newVariant: any = Object.values(productData.variants).find(
        (v: any) => {
          const count = productData.options.reduce(
            (acc: any, option: any, index: number) => {
              if (v[`option${index + 1}`] === newState[option.id]) {
                acc += 1
              }
              return acc
            },
            0,
          )
          return count === productData.options.length
        },
      )
      setSelectedVariantId(newVariant.id)
      return newState
    })
  }

  const { protocol, hostname } = new URL(appLocation.productURL || '')
  const cartURL = `${protocol}//${hostname}/cart/${selectedVariantId}:1`

  return (
    <WidgetPageContainer videoVariant={false}>
      <WidgetHeaderBar bgVariant />
      {productData ? (
        <Stack
          key={productData.id}
          gap={2}
          css={{
            width: '100%',
            height: '100%',
            padding: '$4',
            justifyContent: 'space-between',
            alignItems: 'center',

            '>*': {
              pointerEvents: 'auto !important',
            },

            button: {
              width: '100%',
            },
          }}
        >
          <Stack
            direction={'row'}
            gap={2}
            css={{
              width: '100%',
              height: 0,
              flexGrow: 1,
              justifyContent: 'space-between',
              img: { maxWidth: '100%', maxHeight: '100%' },
              button: { width: 'min-content', fontSize: '20px' },
            }}
          >
            <Button variant={'blank'} onClick={previousImage}>
              <ArrowLeft />
            </Button>
            <Stack
              css={{
                width: '100%',
                height: '100%',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <img key={image.src} src={image.src} alt={image.alt} />
            </Stack>
            <Button variant={'blank'} onClick={nextImage}>
              <ArrowRight />
            </Button>
          </Stack>
          <SlideIndicator
            count={productData.images.length}
            selectedIndex={selectedImage}
          />
          <Stack gap={2} css={{ width: '100%' }}>
            <Stack>
              <h4>{productData.vendor}</h4>
              <h3>{productData.title}</h3>
            </Stack>
            {productData.options.map((option: any) => {
              return (
                !(option.name == 'Title' && option.values.length == 1) && (
                  <Stack key={option.id}>
                    <label>{option.name}</label>
                    <select
                      name={option.id}
                      value={selectedOptions[option.id]}
                      onChange={onOptionChange}
                      className={cn(selectStyles(), buttonStyles())}
                    >
                      {option.values.map((value: string) => {
                        return (
                          <option key={value} value={value}>
                            {value}
                          </option>
                        )
                      })}
                    </select>
                  </Stack>
                )
              )
            })}
            {/*eslint-disable-next-line*/}
            <a
              href={cartURL}
              target={'_blank'}
              rel="noopener"
              className={buttonStyles({ variant: 'primary' })}
            >
              {cartData &&
                new Intl.NumberFormat(
                  'en-GB', // BCP 47 language tag
                  {
                    style: 'currency', // we want a currency
                    currency: cartData.currency, // ISO 4217 currency code
                  },
                ).format(selectedVariant?.price)}
            </a>
          </Stack>
        </Stack>
      ) : (
        <i className={cn('fas fa-circle-notch fa-spin', spinnerStyles())} />
      )}
      <div className={spacerStyles()} />
    </WidgetPageContainer>
  )
}

const selectStyles = css({
  padding: '$2 $3',
})

const spinnerStyles = css({
  position: 'absolute !important',
  inset: 0,
  margin: 'auto !important',
  width: 75,
  height: 75,
  fontSize: 75,
  opacity: 0.7,
})
